module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cz_info display_column"
  }, [_c('div', {
    staticClass: "info_model display_wrap_as"
  }, [_c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n          项目名称\n          "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "项目名称",
      "readonly": _vm.isread
    },
    model: {
      value: (_vm.dataList.prjname),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "prjname", $$v)
      },
      expression: "dataList.prjname"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("项目类别")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataList.Typename),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "Typename", $$v)
      },
      expression: "dataList.Typename"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("所属单位")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dw.DWMC),
      callback: function($$v) {
        _vm.$set(_vm.dw, "DWMC", $$v)
      },
      expression: "dw.DWMC"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n          申报年份\n          "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "year",
      "placeholder": "申报年份",
      "options": _vm.options
    },
    model: {
      value: (_vm.dataList.proYear),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "proYear", $$v)
      },
      expression: "dataList.proYear"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("合作单位")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.dataList.hzdw),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "hzdw", $$v)
      },
      expression: "dataList.hzdw"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.dataList.hzdwphone),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "hzdwphone", $$v)
      },
      expression: "dataList.hzdwphone"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row",
    staticStyle: {
      "height": "120px"
    }
  }, [_c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "120px",
      "line-height": "120px"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("项目负责人")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n            姓名\n            "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n            学历\n            "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n            联系电话\n            "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_c('Input', {
    model: {
      value: (_vm.dataList.fzrname),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "fzrname", $$v)
      },
      expression: "dataList.fzrname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder"
  }, [_c('Input', {
    model: {
      value: (_vm.dataList.fzreducation),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "fzreducation", $$v)
      },
      expression: "dataList.fzreducation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder",
    staticStyle: {
      "border": "none"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.dataList.fzrphone),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "fzrphone", $$v)
      },
      expression: "dataList.fzrphone"
    }
  })], 1)]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("出生年月")]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder"
  }, [_vm._v("职称")]), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder",
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("邮箱")])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.dataList.fzrbirth),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "fzrbirth", $$v)
      },
      expression: "dataList.fzrbirth"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder"
  }, [_c('Input', {
    model: {
      value: (_vm.dataList.fzrjobtitle),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "fzrjobtitle", $$v)
      },
      expression: "dataList.fzrjobtitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infobottomborder",
    staticStyle: {
      "border": "none"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.dataList.fzremail),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "fzremail", $$v)
      },
      expression: "dataList.fzremail"
    }
  })], 1)])], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "80px",
      "line-height": "80px"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("项目组人数")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n            高级\n            "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', [_c('Input', {
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: (_vm.dataList.high_level),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "high_level", $$v)
      },
      expression: "dataList.high_level"
    }
  })], 1)]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n            中级\n            "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', [_c('Input', {
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: (_vm.dataList.middle_level),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "middle_level", $$v)
      },
      expression: "dataList.middle_level"
    }
  })], 1)]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n            初级\n            "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', [_c('Input', {
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: (_vm.dataList.junior),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "junior", $$v)
      },
      expression: "dataList.junior"
    }
  })], 1)]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "infobottomborder"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n            其他\n            "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', [_c('Input', {
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: (_vm.dataList.othernum),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "othernum", $$v)
      },
      expression: "dataList.othernum"
    }
  })], 1)])], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row",
    staticStyle: {
      "height": "80px"
    }
  }, [_c('Col', {
    staticClass: "infoleftborder",
    staticStyle: {
      "height": "80px",
      "line-height": "20px",
      "padding-top": "20px"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("\n        主要研究内容\n        "), _c('br'), _vm._v("和关键技术\n        "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    staticStyle: {
      "height": "80px",
      "line-height": "80px"
    },
    attrs: {
      "span": "19"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.dataList.note),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "note", $$v)
      },
      expression: "dataList.note"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.dataList.startdate),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "startdate", $$v)
      },
      expression: "dataList.startdate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_vm._v("结束时间")]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.dataList.enddate),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "enddate", $$v)
      },
      expression: "dataList.enddate"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "info_model_row",
    staticStyle: {
      "border-bottom": "1px solid #176095"
    }
  }, [_c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n          总经费\n          "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "9"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "81%",
      "margin-right": "12px"
    },
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: (_vm.dataList.allfunds),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "allfunds", $$v)
      },
      expression: "dataList.allfunds"
    }
  }), _vm._v("万元\n      ")], 1), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder",
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._v("\n          申请园林局拨款\n          "), _c('span', {
    staticClass: "media_w_w20",
    staticStyle: {
      "color": "red",
      "margin-top": "4px"
    }
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('Col', {
    staticClass: "infoleftborder inforightborder",
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "65%",
      "margin-right": "12px"
    },
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: (_vm.dataList.yljfunds),
      callback: function($$v) {
        _vm.$set(_vm.dataList, "yljfunds", $$v)
      },
      expression: "dataList.yljfunds"
    }
  }), _vm._v("万元\n      ")], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('Row', {
    staticClass: "info_model_row"
  }, [_c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mod_isshow),
      expression: "!mod_isshow"
    }],
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("上传申报书")]), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mod_isshow),
      expression: "!mod_isshow"
    }],
    staticStyle: {
      "margin-top": "20px",
      "text-align": "left"
    },
    attrs: {
      "span": "9"
    }
  }, [_c('Upload', {
    ref: "fileinfo",
    attrs: {
      "multiple": "",
      "action": _vm.fileAction,
      "on-error": _vm.uplloadError,
      "format": ['docx', 'doc'],
      "on-format-error": _vm.handleFormatError,
      "on-success": _vm.uplloadSucess
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "info",
      "icon": "ios-cloud-upload-outline",
      "title": "申报书上传"
    },
    on: {
      "click": _vm.updata
    }
  }, [_vm._v("上传")])], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "span": "10"
    }
  }, [_c('div', {
    staticClass: "btn display_row_je dispaly_flex00"
  }, [_c('Button', {
    attrs: {
      "id": "confirmbtn",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.click_save()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {
        return _vm.click_reset()
      }
    }
  }, [_vm._v("重置")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "上传申报书",
      "mask-closable": false,
      "footer-hide": ""
    },
    on: {
      "on-cancel": _vm.modal_operate_cancel
    },
    model: {
      value: (_vm.model_operate),
      callback: function($$v) {
        _vm.model_operate = $$v
      },
      expression: "model_operate"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-top": "40px",
      "font-size": "18px",
      "display": "flex"
    }
  }, [_c('div', [_vm._v("上传申报书：")]), _vm._v(" "), _c('div', [_c('Upload', {
    ref: "fileinfo",
    attrs: {
      "multiple": "",
      "action": _vm.fileAction,
      "on-error": _vm.uplloadError,
      "format": ['docx', 'doc'],
      "on-format-error": _vm.handleFormatError,
      "on-success": _vm.uplloadSucess
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "info",
      "icon": "ios-cloud-upload-outline",
      "title": "申报书上传"
    },
    on: {
      "click": _vm.updata
    }
  }, [_vm._v("上传")])], 1)], 1)]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.modal_operate_cancel
    }
  }, [_vm._v("取消")])], 1)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-02f96394"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/theme/right/new_information/new_information.vue
// module id = 1065
// module chunks = 1